import { Component, input, output, ViewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { UiCallFlow } from '../teams-auto-attendants-call-flow.component';
import { FormsModule } from '@angular/forms';
import { AutoAttendantHoliday } from '../../../../shared/models/generated/ziroModels';
import { CallFlowDestinationsFormComponent } from '../call-flow-destinations/call-flow-destinations-form.component';
import { CallFlowGreetingsEntity } from '../call-flow-greetings/call-flow-greetings-form.component';
import { ZiroFormsModule } from '../../../../forms/ziro-forms.module';

@Component({
  selector: 'ziro-auto-attendants-call-flow-edit',
  imports: [TranslateModule, FormsModule, ZiroFormsModule, CallFlowDestinationsFormComponent],
  templateUrl: './teams-auto-attendants-call-flow-edit.component.html',
})
export class TeamsAutoAttendantsCallFlowEditComponent {
  @ViewChild(CallFlowDestinationsFormComponent) destinationsForm?: CallFlowDestinationsFormComponent;

  tenantId = input.required<string>();
  callFlow = input.required<UiCallFlow>();
  allHolidays = input.required<AutoAttendantHoliday[]>();

  greetingUpdate = output<CallFlowGreetingsEntity>();

  validateAndShowErrors(): boolean {
    return this.isValid();
  }

  isValid(): boolean {
    return !this.destinationsForm || this.destinationsForm.validateAndShowErrors();
  }
}
